import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Interventions } from 'src/app/model/installation/interventions.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-interventions',
  templateUrl: './installation-interventions.component.html',
  styleUrls: ['./installation-interventions.component.scss']
})

export class InstallationInterventionsComponent implements OnInit {

  @Input() idMachine: any;
  @Input() loading: boolean = true;
  @Input() suiviCount: any;
  
  constructor(private service: InstallationsService) { }

  public interventions !: Interventions;
  public p: any = 0;

  ngOnInit(): void {
    this.loadInterventions();
  }

  /**
   * Detection d'un changement de l'id machine, ou qu'il faut afficher le loading 
   * @param change 
   */
   async ngOnChanges(change: SimpleChanges) {
  
    if( change.loading ) {
      this.loading = true;
    }

    if(change.idMachine){
      this.idMachine = change.idMachine.currentValue;
      this.loadInterventions();
    } 
  }

  private loadInterventions(){  
    this.loading = true;
    this.service.getInterventionsData(this.idMachine, this.p).subscribe((interventions) => {
      this.interventions = interventions;
      this.loading = false;
      // console.log(this.interventions)
    })
  }

  public pageChange(e: any) {
    this.p = e;
    this.loadInterventions();
  }

}
